import { createTheme } from "@mui/material/styles";
import "./fonts.css";

const theme = createTheme({
  palette: {
    primary: {
      main: "#03a696",
    },
    secondary: {
      main: "#333",
    },
    background: {
      default: "#f4f6f8",
    },
  },

  typography: {
    fontFamily: "Noto Sans JP, sans-serif",
    h1: {
      fontSize: 50,
      fontWeight: 600,
    },
    h2: {
      fontSize: 40,
      fontWeight: 500,
    },
    h3: {
      fontSize: 25,
      fontWeight: 500,
    },
    h4: {
      fontSize: 20,
      fontWeight: 500,
    },
    h5: {
      fontSize: 18,
      fontWeight: 500,
    },
    h6: {
      fontSize: 15,
      fontWeight: 500,
    },
    body1: {
      fontSize: 16,
      fontWeight: 400,
    },
    body2: {
      fontSize: 13,
      fontWeight: 300,
    },
    button: {
      fontSize: 17,
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: "#03a696",
          color: "#ffffff",
          "&:hover": {
            backgroundColor: "#333"
          },
        },
        outlined: {
          borderColor: "#03a696",
          color: "#03a696",
          "&:hover": {
            borderColor: "#333",
            backgroundColor: "#ccc",
          },
        },
        text: {
          color: "#03a696",
          "&:hover": {
            backgroundColor: "#ccc",
            color: "#fff"
          },
        },
      },
    },
  },
});

export default theme;
